import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { allCategoriesWithObj } from "auth/actions/objActions";

export function useForms() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const company = useSelector((state) => state.user.company);

  useEffect(() => {
    async function fetchForms() {
      if (!company?.unitId) return;

      setLoading(true);
      try {
        const response = await allCategoriesWithObj(company.unitId);

        if (response?.message && Array.isArray(response.message)) {
          const formattedForms = response.message.map(form => ({
            id: form._id,
            name: form.name,
            shortName: form.name.replace("obj_", ""),
          }));
          setForms(formattedForms);
        } else {
          setForms([]);
        }
      } catch (error) {
        setForms([]);
      } finally {
        setLoading(false);
      }
    }

    fetchForms();
  }, [company?.unitId]);

  return { forms, loading };
}
